var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1608_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.40671 5.649C0.852953 4.99986 1.31425 4 2.1675 4L7.5 4L12.8574 4C13.7065 4 14.1692 4.99147 13.6238 5.64229L8.32655 11.9637C7.92916 12.4379 7.20085 12.4411 6.79931 11.9704L1.40671 5.649Z",
    fill: "#494545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1608_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTriangle);
export default __webpack_public_path__ + "static/media/small-triangle.0dfadc009cfab8ed009fd8339a18712d.svg";
export { ForwardRef as ReactComponent };